// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3OxIu","container":"styles_container__1YKqK","title":"styles_title__15gWb","wrapper":"styles_wrapper__1PoEy","answer":"styles_answer__nYg8F"};